import "./typography.scss";
import React from "react";
import variables from "../../styles/variables.scss";

export const Body = ({ children, align, color }) => {
  if (!align) {
    align = "left";
  }

  const styles = {
    body: {
      textAlign: align,
      color: color,
    },
  };

  return (
    <div className="body" style={styles.body}>
      {children}
    </div>
  );
};

export const Header = ({ type, text, children, align, color, padding }) => {
  if (!type) {
    type = "h1";
  }
  if (!color) {
    color = variables.accentDark;
  }
  if (!align) {
    align = "left";
  }

  const styles = {
    header: {
      color: color,
      textAlign: align,
      padding: padding,
    },
  };

  return (
    <>
      {type === "h1" ? (
        <h1 style={styles.header}>{children ? children : text}</h1>
      ) : type === "h2" ? (
        <h2 style={styles.header}>{children ? children : text}</h2>
      ) : type === "h3" ? (
        <h3 style={styles.header}>{children ? children : text}</h3>
      ) : type === "h4" ? (
        <h4 style={styles.header}>{children ? children : text}</h4>
      ) : type === "h5" ? (
        <h5 style={styles.header}>{children ? children : text}</h5>
      ) : null}
    </>
  );
};

export const Footnote = ({ align, children, color }) => {
  if (!align) {
    align = "left";
  }
  if (!color) {
    color = variables.gry3;
  }

  const styles = {
    footnote: {
      textAlign: align,
      color: color,
    },
  };

  return (
    <div className="footnote" style={styles.footnote}>
      {children}
    </div>
  );
};
